import { defineComponent } from 'vue'
import './foals.css'
import styles from './index.module.scss'

export default defineComponent({
  name: 'RichTextCom',
  props: {
    content: {
      type: String,
      default: () => '',
      required: true
    }
  },
  setup(props) {
    return () => {
      const { content = '' } = props
      return (
        <div class={'fr-box fr-basic fr-top'}>
          <div
            class={`${styles['rich-txt']} fr-element fr-view`}
            v-html={content}
          />
        </div>
      )
    }
  }
})
